const Footer = () => (
    <>
        <h2>Links</h2>
        <ul>
            <li><a href='https://www.linkedin.com/in/joel-milligan-14012417b/'>LinkedIn</a></li>
            <li><a href='https://github.com/Joel-Milligan'>GitHub</a></li>
        </ul>
    </>
);

export default Footer;